import { NewsData, PagingData } from "../entity";
import { ApiService, DOMUtil, WebshopResponsiveConfiguration } from "webshop-modules";
import { PagingItemProvider } from "./paging-item.provider";
import { DOMElementEvent } from "webshop-modules/dom/DOMElementEvent.enum";

export class Paging {

    public static initialize(data: PagingData): void {
        const triggerElement = document.querySelector('.paging-trigger');
        const container = document.querySelector('.paging-list-container');

        if (!triggerElement || !container) {
            return;
        }

        triggerElement.classList.remove('no-js');

        const apiService = Paging.setupApiService();
        let nextPath = data.nextPath;

        triggerElement.addEventListener(DOMElementEvent.Click, (e) => {
            e.preventDefault();

            apiService.loadNews<NewsData>(nextPath).then(res => {
                const responseData: NewsData = res.data.data;

                nextPath = responseData.pagination.nextPath;
                Paging.updatePaginationAndRenderItems(data, responseData, triggerElement, container);
            })
        });
    }

    private static setupApiService(): ApiService {
        const config: WebshopResponsiveConfiguration = <WebshopResponsiveConfiguration>DOMUtil.getWebshopResponsiveConfig(document);

        return ApiService.getInstance({ clientId: config.poolId! });
    }

    private static updatePaginationAndRenderItems(pagingData: PagingData, responseData: NewsData, triggerElement: Element, container: Element) {
        if (!responseData.hasPagination) {
            container.removeChild(triggerElement);
        }

        responseData.list.forEach((item) => {
            const newElement = PagingItemProvider.getTemplateForType(pagingData.itemType, item, pagingData.basePath, responseData.lang);

            if (newElement) {
                const referenceChild = container.children[container.childElementCount - 1];

                if (referenceChild) {
                    container.insertBefore(newElement, referenceChild);
                } else {
                    container.appendChild(newElement);
                }
            }
        });
    }

}
